import { render, staticRenderFns } from "./supplement-money-manage.vue?vue&type=template&id=3e38da1a"
import script from "./supplement-money-manage.vue?vue&type=script&lang=ts"
export * from "./supplement-money-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports